export const flows = {
    flow_a: {
        version: "flow_a",
        pages: [
            "GlutenSensitivity1",
            "WhatPlacesDoYouWant1",
            "LocationPreference",
            "OccasionTypes",
            // 'WebsiteHopping',
            // 'CommunityParticipation',
            "CommunityMap",
            // 'Paywall',
            // 'Payment',
            'EmailScreen1',
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_b: {
        version: "flow_b",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            // "CommunityValidationStatement",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            "CommunityMap",
            'EmailScreen1',
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_c: {
        version: "flow_c",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            'EmailScreen2',
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            // "CommunityValidationStatement",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            "CommunityMap",
            "PreCheckout",
        ],
        components: {
            drawerButton: "DrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSlider"
        }
    },
    flow_d: {
        version: "flow_d",
        pages: [
            "GlutenSensitivity1",
            "AtlyIntro1",
            'EmailScreen2',
            "DietaryRestrictions",
            'TagsStatement',
            "SearchTarget",
            // "CommunityValidationStatement",
            "FeaturePreference",
            "SafetyRankingExplanation",
            "SafetyRankingStatement",
            "InformationSources",
            "ReviewAggregationStatement",
            "WhatPlacesDoYouWant1",
            "InformationAccuracyQuestion",
            "InformationUpdateStatement",
            //"SafetyCommitmentStatement",
            "CommunityMap",
            "PreCheckout",
        ],
        components: {
            drawerButton: "SimpleDrawerButton",
            footerDrawer: "FooterDrawerUI",
            quizSlider: "QuizSliderCosmic"
        }
    },
    flow_e: {
        version: "flow_e",
        pages: [
            "GlutenSensitivity1",
            "WhatPlacesDoYouWant1",
            "Statement1",
            "GlutenSensitivity2",
            "DietaryRestrictions",
            "DiningPreference",
            "PriceRange",
            "WhatPlacesDoYouWant1",
        ],
    },
    flow_f: {
        version: "flow_f",
        pages: [
            "GlutenSensitivity1",
            "SearchTarget",
            "DiningChallenges",
            "SafetyRankingStatement", // first statement
            "CommunityValidationStatement",
            "GlobalCoverageStatement",
            "AggregatedInfoStatement",
            "DietitianStatement",
            "RealtimeUpdatesStatement",
            "CrossContaminationStatement",
            "TravelFeaturesStatement", // last statement
            "CommunityMap",
            'EmailScreen1',
            "PreCheckout",
        ],
    }
};
